import React, { FunctionComponent } from 'react';
import { II18n } from '../../../models';
import { BrassIcon } from '../icon/Icon';
import { BrassButtonSharedPropsV1, BrassButtonSharedV1 } from './ButtonV1';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

const BrassButtonAddV1: FunctionComponent<BrassButtonSharedPropsV1> = (
  props: BrassButtonSharedPropsV1,
) => (
  <BrassButtonSharedV1
    themeColor='primary'
    className='brass-button-add'
    labelKey='add'
    tooltipKey='clickToAdd'
    translations={translations}
    icon={<BrassIcon icon={faPlus} size='lg' />}
    {...props}
  />
);

const translations: II18n = {
  es: {
    add: 'Agregar',
    clickToAdd: 'Haga clic para agregar',
  },
  enUS: {
    add: 'Add',
    clickToAdd: 'Click to add',
  },
  ptBR: {
    add: 'Adicionar',
    clickToAdd: 'Clique para adicionar',
  },
};

export { BrassButtonAddV1 };
